import React, {useEffect} from 'react';
import Image from "next/image";
import {Select} from "antd";
import {formatNumber, formatUSDNumber} from "../../../utils/currencyConverter";


const MAPPING_PERIOD_NUMBER = {
  'seven_day': 7,
  'ten_day': 10,
  'fifteen_day': 15,
  'one_month': 30,
}


function SlickCarouselItem({dataItem, isTravelAbroad, t, i18n}) {

  const [periodList, setPeriodList] = React.useState([]);
  const [currentPrice, setCurrentPrice] = React.useState(0);
  const [selectedPeriod, setSelectedPeriod] = React.useState(null);




  useEffect(() => {
    if (dataItem?.period_price) {
      const currentPeriodList = Object.entries(dataItem?.period_price)
        .filter((item) => item[1]) // Lọc ra những gói cước không có giá hoặc giá = 0
        .filter((item) => MAPPING_PERIOD_NUMBER[item[0]]) // Loc thoi han goi co the mapping
        .sort((a, b) => MAPPING_PERIOD_NUMBER[a[0]] - MAPPING_PERIOD_NUMBER[b[0]]) // Sắp xếp theo thứ tự tăng dần của thời gian
      console.log('currentPeriodList', currentPeriodList)
      setCurrentPrice(currentPeriodList?.[0]?.[1])   // Giá gói cước mặc định khi hiển thị component
      setSelectedPeriod(currentPeriodList[0])

      setPeriodList(currentPeriodList)
    }
    else {
      setPeriodList([])
    }
  }, [dataItem]);

  const renderCurrency = () => {
    const language = i18n.language
    console.log(language, '123123');
    if (language === 'en') {
      return '$'
    }
    if (language === 'zh') {
      return '¥'
    }
    return 'VND'
  }

  const handleChangePeriod = (value) => {
    const selectedPeriod = periodList.find((item) => item[0] === value)
    setSelectedPeriod(selectedPeriod)
    setCurrentPrice(selectedPeriod[1])
  }

  return (
    <div className="carousel-item">
      <div className="image-section">
        <div className="image-block">
          <div className="image-item">
            <Image
              src={dataItem?.image}
              alt="sim-sing"
              width={338}
              height={338}
            />
          </div>
        </div>
      </div>
      <div className="content-section">
        <div className="carousel-title">{dataItem?.title}</div>
        <div
          className="carousel-sub-title"
          dangerouslySetInnerHTML={{ __html: dataItem?.subtitle }}
        />
        <div
          className="carousel-content"
          dangerouslySetInnerHTML={{ __html: dataItem?.description?.replace(/&nbsp;/g, ' ') }}
        />
        {/* {
          !!periodList?.length && (
            <div className={'period-title'}>{t('package_infomation')}</div>)
        } */}
        {
          !!periodList?.length &&
          <div className={'select-period-block'}>
            <Select onChange={handleChangePeriod} value={selectedPeriod} className={'select-box-period'}>
              {periodList.map((item, index) => (
                <Select.Option value={item[0]} key={item[0]}>{`${MAPPING_PERIOD_NUMBER[item[0]]} ${t('days')}`}</Select.Option>
              ))}

            </Select>
            <div className={'product-price'}>{formatUSDNumber(currentPrice)} {renderCurrency()}</div>
          </div>
        }
        {isTravelAbroad ? (
          <button className="contact-button" aria-hidden="true">
            {t(isTravelAbroad ? 'tourists-to-vietnam.contact' : 'tourists-to-vietnam.order')}
          </button>
        ) : (
          <a href="#sim-order" style={{ textDecoration: 'none' }} aria-hidden="true">
            <button className="contact-button">
              {t(isTravelAbroad ? 'tourists-to-vietnam.contact' : 'tourists-to-vietnam.order')}
            </button>
          </a>
        )}
      </div>
    </div>
  );
}

export default SlickCarouselItem;
